import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../api/axios";
import toast from "react-hot-toast";

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const response = await api.get("/setting");
      setSettings(response.data);
    } catch (err) {
      console.error("Settings yüklenirken hata:", err);
      setSettings({});
      toast("Henüz ayar bulunamadı. Varsayılan ayarlar yüklendi.", { icon: "⚠️" });
    } finally {
      setLoading(false);
    }
  };

  const updateSettings = async (updatedSettings) => {
    try {
      await api.put("/setting", updatedSettings);
      setSettings(updatedSettings);
      toast.success("Ayarlar başarıyla güncellendi");
      return true;
    } catch (err) {
      console.error("Settings güncellenirken hata:", err);
      toast.error("Ayarlar güncellenirken hata oluştu");
      return false;
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading, fetchSettings, updateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;
